import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IMAGES } from "../../assets";
import { STRINGS } from "../../constants";
import { SemiCircleProgress } from "react-semicircle-progressbar";
import IconTint from "react-icon-tint";
import { AuthContext } from "../../context";

const SubmitQuestionList = (props) => {
  const questionList = props?.questionList;

  const { t } = useTranslation();
  const { activeLanguage } = useContext(AuthContext);

  const [statistics, setStatistics] = useState(null);

  useEffect(() => {}, [props]);
  useEffect(() => {
    calculatePercentage();
  }, []);

  function calculatePercentage() {
    const totalQuestion = questionList.length;
    var correctAnswerCount = 0;
    var wrongAnswerCount = 0;
    questionList.forEach((e) => {
      if (e.questionType?.pattern == "Multiple Choice") {
        if (e.answer == e.selectedAnswer) {
          correctAnswerCount = correctAnswerCount + 1;
        } else {
          wrongAnswerCount = wrongAnswerCount + 1;
        }
      } else if (e.questionType?.pattern == "Checkbox") {
        if (e?.selectedAnswer?.length == e?.answer?.length) {
          let isCorrect = true;

          e?.selectedAnswer.forEach((element) => {
            if (!(e?.answer ?? []).includes(element)) {
              isCorrect = false;
            }
          });

          if (isCorrect) {
            correctAnswerCount = correctAnswerCount + 1;
          } else {
            wrongAnswerCount = wrongAnswerCount + 1;
          }
        } else {
          wrongAnswerCount = wrongAnswerCount + 1;
        }
      }
    });

    setStatistics({
      correct: correctAnswerCount,
      incorrect: wrongAnswerCount,
      total: totalQuestion,
      percentage: parseFloat(
        (100 * correctAnswerCount) / totalQuestion
      ).toFixed(2),
    });
  }
  const getTextColorClass = (isCorrect, isIncorrect) => {
    if (isCorrect) {
      return "text-[#52BB00]";
    } else if (isIncorrect) {
      return "text-[#E51B00]";
    } else {
      return "text-[#8A8A8A]";
    }
  };

  return (
    <div>
      {questionList?.length > 0 && (
        <div>
          <div className="shadow-[#FE6B011A] shadow-md  bg-[#FFFFFF]  p-2 m-2 rounded-2xl ">
            <div className="h-32 flex items-center justify-center">
              <div className="relative">
                <SemiCircleProgress
                  showPercentValue={false}
                  percentage={statistics?.percentage}
                  size={{
                    width: 200,
                    height: 200,
                  }}
                  strokeWidth={5}
                  hasBackground
                  strokeColor="#FE6B01"
                  className="relative"
                />
                <div className="percentage_text text-base font-medium">
                  {activeLanguage === "Marathi"
                    ? new Intl.NumberFormat("mr", {
                        maximumSignificantDigits: 2,
                      }).format(statistics?.percentage) + " %"
                    : statistics?.percentage + " %"}
                </div>
              </div>
            </div>
            <div className="flex items-center justify-around">
              <div>
                {activeLanguage === "Marathi" ? (
                  <p className="text-[#52BB00] text-center text-base font-normal">
                    {" "}
                    {new Intl.NumberFormat("mr", {
                      maximumSignificantDigits: 2,
                    }).format(statistics?.correct) ?? "0"}
                  </p>
                ) : (
                  <p className="text-[#52BB00] text-center text-base font-normal">
                    {" "}
                    {statistics?.correct ?? "0"}
                  </p>
                )}
                <p className="text-[#52BB00] text-center text-base font-normal">
                  {" "}
                  {t(STRINGS.correct_answers)}
                </p>
              </div>
              <div>
                {activeLanguage === "Marathi" ? (
                  <p className="text-[#E51B00] text-center text-base font-normal">
                    {" "}
                    {new Intl.NumberFormat("mr", {
                      maximumSignificantDigits: 2,
                    }).format(statistics?.incorrect) ?? "0"}
                  </p>
                ) : (
                  <p className="text-[#E51B00] text-center text-base font-normal">
                    {" "}
                    {statistics?.incorrect ?? "0"}
                  </p>
                )}
                <p className="text-[#E51B00] text-center text-base font-normal">
                  {" "}
                  {t(STRINGS.wrong_answers)}
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-base mt-4"> {t(STRINGS.your_answers)}</h2>
            <div className="h-72 overflow-y-scroll my-2">
              {questionList?.map((item, index) => {
                let selectedOptions = [];
                if (item?.selectedAnswer) {
                  const selectedItem = Array.isArray(item?.selectedAnswer)
                    ? item.selectedAnswer
                    : [item.selectedAnswer];
                  if (selectedItem) {
                    selectedItem.forEach((element) => {
                      const indexOptions = item?.option?.indexOf(element);
                      if (indexOptions >= 0) {
                        selectedOptions.push(
                          `${(indexOptions + 10).toString(36).toUpperCase()}`
                        );
                      }
                    });
                  }
                }

                let correctOptions = [];
                if (item?.answer) {
                  const selectedItem = Array.isArray(item?.answer)
                    ? item.answer
                    : [item.answer];
                  selectedItem.forEach((element) => {
                    const indexOptions = item?.option?.indexOf(element);
                    if (indexOptions >= 0) {
                      correctOptions.push(
                        `${(indexOptions + 10).toString(36).toUpperCase()}`
                      );
                    }
                  });
                }

                return (
                  <div
                    key={item?.option}
                    className="p-3 rounded-xl bg-[#FDFDFD] mt-3 "
                  >
                    <p className="text-base font-medium">{`${
                      activeLanguage === "Marathi"
                        ? new Intl.NumberFormat("mr", {
                            maximumSignificantDigits: 2,
                          }).format(index + 1)
                        : index + 1
                    }. ${item?.question}`}</p>

                    <div>
                      {item?.option?.map((e, indexO) => {
                        const isCorrect =
                          item?.questionType?.pattern == "Multiple Choice"
                            ? item.answer == e
                            : item?.answer?.includes(e);
                        let isIncorrect = false;
                        if (
                          !isCorrect &&
                          ((Array.isArray(item.selectedAnswer) &&
                            item.selectedAnswer.includes(e)) ||
                            (item.selectedAnswer == e &&
                              item?.questionType?.pattern == "Multiple Choice"))
                        ) {
                          isIncorrect = true;
                        }

                        return (
                          <div
                            key={e}
                            className="text-sm font-normal flex items-center justify-between py-2"
                          >
                            <p
                              className={getTextColorClass(
                                isCorrect,
                                isIncorrect
                              )}
                            >
                              {`${(indexO + 10).toString(36).toUpperCase()}.`}{" "}
                              {e}
                            </p>
                            <div>
                              {item?.questionType?.pattern ==
                                "Multiple Choice" && (
                                <>
                                  {isCorrect ? (
                                    <IconTint
                                      className="w-4 h-4 "
                                      src={IMAGES.radioButtonIcon}
                                      color="#52BB00"
                                    />
                                  ) : (
                                    <>
                                      {isIncorrect ? (
                                        <IconTint
                                          className="w-4 h-4 "
                                          src={IMAGES.radioButtonIcon}
                                          color="#E51B00"
                                        />
                                      ) : (
                                        <img
                                          alt="roundicon"
                                          className="w-4 h-4 object-contain"
                                          src={IMAGES.roundIcon}
                                        />
                                      )}
                                    </>
                                  )}
                                </>
                              )}

                              {item?.questionType?.pattern == "Checkbox" && (
                                <>
                                  {isCorrect ? (
                                    <img
                                      alt="radiocorrect"
                                      className="w-4 h-4 object-contain"
                                      src={IMAGES.radioCorrectIcon}
                                    />
                                  ) : (
                                    <>
                                      {isIncorrect ? (
                                        <img
                                          alt="radio"
                                          className="w-4 h-4 object-contain"
                                          src={IMAGES.radioCorrectIcon}
                                        />
                                      ) : (
                                        <img
                                          alt="round"
                                          className="w-4 h-4 object-contain"
                                          src={IMAGES.roundIcon}
                                        />
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <p className="text-xs text-[#52BB00]">
                      {`${t(STRINGS?.correct)} : `} {correctOptions.join(" & ")}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubmitQuestionList;
